import React from "react";
import inputstyles from "./input.module.css";
import basestyles from "../../styles/basestyles.module.css";

export default function Input(props) {
  return (
    <>
      <div className={basestyles.inputWidth}>
        <input
          className={inputstyles.inputTag}
          type={props.type}
          placeholder={props.placeholder}
          min={props.min}
          max={props.max}
          step={props.step}
          onChange={props.onChange}
          name={props.name}
          style={props.style}
          value={props.value}
        />
      </div>
    </>
  );
}
